const Filter = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-filter"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-filter"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path
        d="M7 11H17V13H7V11ZM4 7H20V9H4V7ZM10 15H14V17H10V15Z"
        fill="white"
      />
    </svg>
  );
};

export default Filter;
